import { useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from './../components/services/axiosInstance';
import AuthContext from './../components/services/AuthContext';


const useVideoTracking = (videoId, playerRef) => {
  const { id: courseId } = useParams();
  const { user } = useContext(AuthContext); // Use useContext to access the AuthContext
  const intervalRef = useRef(null);
  const lastPositionRef = useRef(0);

  const sendStatsUpdate = async (timeWatched, currentPosition) => {
    try {
      await axiosInstance.post('/courses/video/stats', {
        videoId,
        timeWatched: timeWatched,
        lastPosition: currentPosition
      });
    } catch (error) {
      console.error('خطأ في تحديث إحصائيات الفيديو:', error); // Translated
    }
  };

  useEffect(() => {
    if (!videoId || !videoId._id || !videoId.nomvideo) {
      console.error('معرف الفيديو غير صالح:', videoId); // Translated
      return;
    }

    const player = playerRef.current;

    const handleTimeUpdate = () => {
      const currentTime = player.currentTime();
      const duration = player.duration();
      const progress = duration > 0 ? currentTime / duration : 0;

      // Only update if position changed significantly (more than 5 seconds)
      if (Math.abs(currentTime - lastPositionRef.current) > 5) {
        sendStatsUpdate(progress, currentTime);
        lastPositionRef.current = currentTime;
      }
    };

    // Set up interval to track progress every 30 seconds
    intervalRef.current = setInterval(() => {
      if (player && player.currentTime) {
        const currentTime = player.currentTime();
        const duration = player.duration();
        const progress = duration > 0 ? currentTime / duration : 0;
        sendStatsUpdate(progress, currentTime);
      }
    }, 30000);

    player.on('timeupdate', handleTimeUpdate);

    return () => {
      clearInterval(intervalRef.current);
      player.off('timeupdate', handleTimeUpdate);
    };
  }, [videoId, playerRef, courseId, user]);

  return null;
};

export default useVideoTracking;


